var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRestourant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.482,
    height: 15.485,
    viewBox: "0 0 15.482 15.485",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0420\\u0435\\u0441\\u0442\\u043E\\u0440\\u0430\\u043D\\u044B",
    transform: "translate(-0.056)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_611",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 611",
    transform: "translate(0.056 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_610",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 610",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1684",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1684",
    d: "M15.084,8.23h-.477a6.821,6.821,0,0,0-5.55-6.245,1.6,1.6,0,0,0,.13-.624,1.361,1.361,0,1,0-2.721,0,1.6,1.6,0,0,0,.13.624A6.879,6.879,0,0,0,.986,8.23H.51a.443.443,0,0,0-.454.441.453.453,0,0,0,.454.454H15.084a.453.453,0,0,0,.454-.454A.443.443,0,0,0,15.084,8.23ZM7.827,1.868a.5.5,0,0,1-.454-.507.454.454,0,1,1,.907,0A.5.5,0,0,1,7.827,1.868Z",
    transform: "translate(-0.056 0)",
    fill: "current"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_613",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 613",
    transform: "translate(0.963 10.939)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_612",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 612"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1685",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1685",
    d: "M30.5,361.685a.449.449,0,0,0-.454.454v3.636a.449.449,0,0,0,.454.454h1.361v-4.543Z",
    transform: "translate(-30.05 -361.685)",
    fill: "current"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_615",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 615",
    transform: "translate(3.685 9.845)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_614",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 614"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1686",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1686",
    d: "M130.47,326.207a.907.907,0,0,0-1.283,0l-2.6,2.585a1.8,1.8,0,0,1-1.211.524h-1.242a.454.454,0,1,1,0-.907h1.4a.91.91,0,0,0,.907-.907.9.9,0,0,0-.907-.9h-.907a.525.525,0,0,1-.408-.109,4.764,4.764,0,0,0-.5-.42,3.234,3.234,0,0,0-3.311-.224.7.7,0,0,0-.378.624v4.66c5.769.008,5.242,0,5.276,0a3.6,3.6,0,0,0,2.566-1.063l2.6-2.6A.892.892,0,0,0,130.47,326.207Z",
    transform: "translate(-120.031 -325.501)",
    fill: "current"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestourant);
export default __webpack_public_path__ + "static/media/Restourant.e98e58b9e6dfb9bf9d5135e13603c8f8.svg";
export { ForwardRef as ReactComponent };